module.exports = __webpack_public_path__ + "media/images/menu/channel_2_off-e3aa1109b823f9005be1d4ea445a3480.jpg";